const TOKEN_KEY = "dh_password_reset_tokens";
const TTL_MS = 1000 * 60 * 60 * 2;

function readTokens() {
  try {
    return JSON.parse(localStorage.getItem(TOKEN_KEY) || "[]");
  } catch {
    return [];
  }
}

function writeTokens(rows) {
  localStorage.setItem(TOKEN_KEY, JSON.stringify(rows.slice(-200)));
}

export function issuePasswordResetToken(userId, email) {
  const token = crypto.randomUUID();
  const row = {
    token,
    userId,
    email: String(email || "").toLowerCase(),
    createdAt: new Date().toISOString(),
    expiresAt: new Date(Date.now() + TTL_MS).toISOString(),
  };
  writeTokens([row, ...readTokens()]);
  return row;
}

export function resetPasswordPath(token) {
  return `/reset-password?token=${encodeURIComponent(token)}`;
}

export function absoluteResetUrl(token) {
  if (typeof window === "undefined") return resetPasswordPath(token);
  return `${window.location.origin}${resetPasswordPath(token)}`;
}

export function findPasswordResetToken(token) {
  const raw = String(token || "").trim();
  if (!raw) return null;
  const now = Date.now();
  return (
    readTokens().find((row) => {
      if (row.token !== raw) return false;
      return new Date(row.expiresAt).getTime() > now;
    }) || null
  );
}

export function consumePasswordResetToken(token) {
  const match = findPasswordResetToken(token);
  if (!match) return null;
  writeTokens(readTokens().filter((row) => row.token !== token));
  return match;
}
